export default "__VITE_ASSET__C_1c7tUu__"